import { Helmet } from "react-helmet-async";

export default function PoliticaPrivacidad() {
  return (
    <div className="min-h-screen pt-20" data-testid="politica-privacidad-page">
      <Helmet>
        <title>Política de Privacidad | SOSTRE BALEAR</title>
        <meta name="description" content="Política de privacidad y protección de datos del sitio web SOSTRE BALEAR." />
        <link rel="canonical" href="https://www.sostrebalear.com/politica-privacidad" />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <section className="py-16 md:py-24 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-sm font-medium tracking-wide uppercase text-[#22c55e]">
            Legal
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mt-3 tracking-tight">
            Política de Privacidad
          </h1>
          <p className="text-slate-500 mt-4">
            Última actualización: Enero 2026
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate max-w-none">
          
          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            1. Responsable del Tratamiento
          </h2>
          <p className="text-slate-600 mb-4">
            En cumplimiento del Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016 (RGPD), y de la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), le informamos que los datos personales que pudieran recabarse serán tratados por:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li><strong>Responsable:</strong> PASTORIA PROJECT SL</li>
            <li><strong>CIF:</strong> B57664179</li>
            <li><strong>Domicilio:</strong> Camí Son Rapinya, nº8 1ºA, 07013 Palma (Illes Balears)</li>
            <li><strong>Correo electrónico:</strong> info@pastoria.es</li>
            <li><strong>Sitio web:</strong> www.pastoria.es</li>
          </ul>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            2. Finalidad del Tratamiento
          </h2>
          <p className="text-slate-600 mb-4">
            Los datos personales que pudieran facilitarse a través de este sitio web serán tratados con las siguientes finalidades:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li>Atender las consultas y solicitudes de información que nos remita.</li>
            <li>Gestionar el envío de información relacionada con el proyecto SOSTRE BALEAR.</li>
            <li>Cumplir con las obligaciones legales que nos sean de aplicación.</li>
            <li>Análisis estadístico y mejora de la experiencia de navegación.</li>
          </ul>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            3. Legitimación del Tratamiento
          </h2>
          <p className="text-slate-600 mb-4">
            La base legal para el tratamiento de sus datos personales es:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li><strong>Consentimiento del interesado:</strong> Al contactar con nosotros o navegar por el sitio web aceptando las cookies.</li>
            <li><strong>Interés legítimo:</strong> Para el análisis y mejora de nuestros servicios.</li>
            <li><strong>Cumplimiento de obligaciones legales:</strong> Cuando sea necesario para cumplir con la normativa aplicable.</li>
          </ul>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            4. Categorías de Datos Tratados
          </h2>
          <p className="text-slate-600 mb-4">
            Este sitio web es principalmente informativo y no recoge datos personales de forma directa. Sin embargo, podemos tratar:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li><strong>Datos de navegación:</strong> Dirección IP, tipo de navegador, páginas visitadas (a través de cookies analíticas).</li>
            <li><strong>Datos de contacto:</strong> Nombre, email y mensaje, únicamente si el usuario decide contactar voluntariamente.</li>
          </ul>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            5. Destinatarios de los Datos
          </h2>
          <p className="text-slate-600 mb-4">
            No se cederán datos a terceros, salvo obligación legal. Podemos utilizar servicios de terceros para:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li>Análisis web (Google Analytics o similares), con datos anonimizados.</li>
            <li>Alojamiento web (hosting).</li>
          </ul>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            6. Plazo de Conservación
          </h2>
          <p className="text-slate-600 mb-6">
            Los datos personales se conservarán mientras sean necesarios para la finalidad para la que fueron recogidos, y posteriormente durante los plazos legalmente establecidos para atender posibles responsabilidades.
          </p>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            7. Derechos del Interesado
          </h2>
          <p className="text-slate-600 mb-4">
            En cualquier momento puede ejercer sus derechos de:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
            <li><strong>Acceso:</strong> Conocer qué datos personales tenemos sobre usted.</li>
            <li><strong>Rectificación:</strong> Solicitar la corrección de datos inexactos.</li>
            <li><strong>Supresión:</strong> Solicitar la eliminación de sus datos.</li>
            <li><strong>Oposición:</strong> Oponerse a determinados tratamientos.</li>
            <li><strong>Limitación:</strong> Solicitar la limitación del tratamiento.</li>
            <li><strong>Portabilidad:</strong> Recibir sus datos en formato estructurado.</li>
          </ul>
          <p className="text-slate-600 mb-6">
            Para ejercer estos derechos, puede dirigirse a <a href="mailto:info@pastoria.es" className="text-[#22c55e] hover:underline">info@pastoria.es</a>, indicando en el asunto "Protección de Datos" y adjuntando copia de su DNI o documento identificativo.
          </p>
          <p className="text-slate-600 mb-6">
            Asimismo, tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD) si considera que sus derechos no han sido atendidos correctamente: <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-[#22c55e] hover:underline">www.aepd.es</a>
          </p>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            8. Medidas de Seguridad
          </h2>
          <p className="text-slate-600 mb-6">
            PASTORIA PROJECT SL ha adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad de los datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado, habida cuenta del estado de la tecnología, la naturaleza de los datos almacenados y los riesgos a que están expuestos.
          </p>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            9. Modificaciones de la Política de Privacidad
          </h2>
          <p className="text-slate-600 mb-6">
            PASTORIA PROJECT SL se reserva el derecho a modificar la presente política para adaptarla a novedades legislativas o jurisprudenciales, así como a prácticas de la industria. En dichos supuestos, se anunciará en esta página los cambios introducidos con razonable antelación a su puesta en práctica.
          </p>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            10. Legislación Aplicable
          </h2>
          <p className="text-slate-600 mb-6">
            Esta Política de Privacidad se rige por la legislación española y europea en materia de protección de datos:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li>Reglamento (UE) 2016/679 (RGPD)</li>
            <li>Ley Orgánica 3/2018, de 5 de diciembre (LOPDGDD)</li>
            <li>Ley 34/2002, de 11 de julio (LSSI-CE)</li>
          </ul>

        </div>
      </section>
    </div>
  );
}
